var map = {
	"./Arrow.svg": 1545,
	"./check-mark-dark.svg": 7693,
	"./check-mark-white.svg": 3138,
	"./email.svg": 9168,
	"./facebook-round.svg": 7115,
	"./icons/email.svg": 7882,
	"./icons/facebook.svg": 3902,
	"./icons/instagram.svg": 673,
	"./icons/map-pin.svg": 4378,
	"./icons/phone.svg": 9193,
	"./icons/pin.svg": 2807,
	"./level-0-badge.svg": 6634,
	"./level-0-ribbon.svg": 3072,
	"./level-1-badge.svg": 2290,
	"./level-1-ribbon.svg": 7897,
	"./logo.png": 6949,
	"./logo_hvit_liten.png": 8709,
	"./map-pin-highlighted.svg": 1125,
	"./map-pin-regular.svg": 9994,
	"./perfect-home-logo-300.svg": 8835,
	"./perfect-home-logo.png": 4173,
	"./perfect-home-logo.svg": 3373,
	"./phone.svg": 6289,
	"./pinterest-round.svg": 4187
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;